import {
  STORE_MERCHANT_SCROLL,
  STORE_ZoneDescription,
  STORE_ZoneId,
} from "../../database/store-names";
import { GET_PUSHNOTIFICATION_REDIRECT_URL } from "../../database/get-stored-data";
import { api_LoadMerchantForMID } from "../../connection/api/api-home";
import { ENCRYPT_STORAGE, CSP } from "../../config/config";
import { PT_GROCERY_CATEGORY } from "../../routes/stack/paths/pt-grocery";
import { set_dto_Merchant } from "../../classes/dto-setters/dto-setter";
import { dto_Customer } from "../../classes/dto-customer";
import { dto_common } from "../../classes/dto-common";
import { PT_LAND } from "../../routes/stack/paths/pt-home";
import SliderImage from "../../components/image-slider/image-slider";
import React from "react";

export default class TypeLanding extends React.Component {
  async componentDidMount() {
    ENCRYPT_STORAGE.removeItem(STORE_MERCHANT_SCROLL);

    if (CSP === "AV") {
      setTimeout(async () => {
        await this.NotificationRedirect();
      }, 50);
    }
  }

  async NotificationRedirect() {
    // let toNavigate = localStorage.getItem("toNavigate"); //Shud comment out this
    let toNavigate = await GET_PUSHNOTIFICATION_REDIRECT_URL();

    if (
      toNavigate &&
      (toNavigate.startsWith("/product-list") ||
        toNavigate.startsWith("/product"))
    ) {
      localStorage.setItem("TimeDifinvalid", true);

      // Extract and parse the MID
      const midMatch = toNavigate.match(/\/MID=(\d+)/);
      const MID = midMatch ? parseInt(midMatch[1]) : null;

      // Extract and parse MerchantZone
      const merchantZoneMatch = toNavigate.match(/\/MerchantZone=(\d+)/);
      const MerchantZone = merchantZoneMatch
        ? parseInt(merchantZoneMatch[1])
        : null;

      if (MerchantZone !== null) {
        dto_common.ZoneId = MerchantZone;
        let ZoneDescription = null;

        switch (dto_common.ZoneId) {
          case 1490:
            ZoneDescription = "Male";
            break;
          case 3:
            ZoneDescription = "Hulhumale Phase2";
            break;
          case 15121:
            ZoneDescription = "Hulhumale";
            break;
        }

        dto_common.ZoneDescription = ZoneDescription;
        ENCRYPT_STORAGE.setItem(STORE_ZoneId, MerchantZone);
        ENCRYPT_STORAGE.setItem(STORE_ZoneDescription, ZoneDescription);
      }

      if (
        MID !== null &&
        (toNavigate.startsWith("/product-list") ||
          toNavigate.startsWith("/product"))
      ) {
        let data = await api_LoadMerchantForMID(dto_common.DineType, MID);
        let objData = JSON.parse(data);
        let MerchantInfo = JSON.parse(objData.MerchantInfo);
        let selectedMerchant = MerchantInfo[0];

        await set_dto_Merchant(selectedMerchant);
        console.log("Selected Merchant:", selectedMerchant);
      }

      // localStorage.removeItem("toNavigate"); //Shud comment out this
      toNavigate = toNavigate.split("/MID")[0];
    }

    if (toNavigate) {
      this.props.navigate(toNavigate);
    }
  }

  render() {
    return (
      <>
        <div style={{ float: "left", padding: 25, width: "65%" }}>
          {dto_Customer.CusName === "" ? (
            <>
              <p
                style={{
                  fontSize: 25,
                  fontFamily: "CerealLight",
                  color: "gray",
                  margin: 0,
                }}
              >
                Welcome to
              </p>
              <div style={{ display: "flex" }}>
                <p
                  style={{
                    color: "#ffd817",
                    fontFamily: "CerealLight",
                    margin: 0,
                    fontSize: 30,
                  }}
                >
                  Avas
                </p>
                <p
                  style={{
                    margin: 0,
                    fontFamily: "CerealLight",
                    fontSize: 30,
                    color: "gray",
                    marginLeft: 5,
                  }}
                >
                  Food
                </p>
              </div>
            </>
          ) : (
            <>
              <p
                style={{
                  fontSize: 25,
                  fontFamily: "CerealLight",
                  color: "gray",
                  margin: 0,
                }}
              >
                Welcome Back
              </p>
              <p
                style={{
                  color: "#ffd817",
                  fontFamily: "CerealLight",
                  margin: 0,
                  fontSize: 30,
                }}
              >
                {dto_Customer.CusName}
              </p>
            </>
          )}
        </div>
        <div
          style={{
            position: "",
            top: 0,
            right: 0,
            width: "35%",
            backgroundColor: "#fbad02",
            height: 350,
            float: "right",
            marginBottom: 20,
            borderBottomLeftRadius: 30,
          }}
        />

        <div style={{ width: "100%", clear: "both", marginTop: 20 }}>
          {/* RESTAURANTS */}
          <div
            style={{
              margin: 5,
              marginTop: 0,
              position: "relative",
              cursor: "pointer",
            }}
            onClick={() => {
              this.props.navigate(PT_LAND);
            }}
          >
            <img
              src={require("./images/restaurant.png")}
              style={{
                width: "100%",
                height: 100,
                objectFit: "cover",
                borderRadius: 5,
              }}
              alt="Restaurants"
            />
            <div
              style={{
                position: "absolute",
                left: 15,
                top: "50%",
                transform: "translateY(-50%)",
                color: "white",
                fontWeight: "bold",
                textTransform: "uppercase",
                fontSize: 28,
                fontFamily: "CerealLight",
                zIndex: 2,
              }}
            >
              RESTAURANTS
            </div>
          </div>

          {/* GROCERY */}
          <div
            style={{
              margin: 5,
              marginTop: 10,
              position: "relative",
              cursor: "pointer",
            }}
            onClick={() => {
              this.props.navigate(PT_GROCERY_CATEGORY);
            }}
          >
            <img
              src={require("./images/grocery.jpg")}
              style={{
                width: "100%",
                height: 100,
                objectFit: "cover",
                borderRadius: 5,
              }}
              alt="Grocery"
            />
            <div
              style={{
                position: "absolute",
                left: 15,
                top: "50%",
                transform: "translateY(-50%)",
                fontWeight: "bold",
                textTransform: "uppercase",
                fontSize: 28,
                fontFamily: "CerealLight",
                zIndex: 2,
              }}
            >
              GROCERY
            </div>
          </div>
        </div>

        {/* SliderImage positioned separately */}
        <div
          style={{
            position: "absolute",
            top: 100,
            right: 0,
            marginBottom: 20,
            borderBottomLeftRadius: 30,
            zIndex: 1,
          }}
        >
          <SliderImage />
        </div>
      </>
    );
  }
}
